import { redirect } from 'react-router-dom'
import { logout } from '../../../core/auth'
import { urls } from '../../../routes/urls'

export function logoutLoader() {
    return logout().then(res => {
        return redirect(urls.adminLogin)
    })
}